import { Checkbox, createStyles } from '@mantine/core';

import { textStyles } from '~/domains/design-system/Text';

import type { TFilterMultiSelect } from '../types';
import { useCallback } from 'react';

const useStyles = createStyles((theme) => ({
  option: {
    padding: `${theme.other.spacing._16}px 0`,

    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.colors.gray2[0]}`,
    },
  },
  labelWrapper: {
    flexGrow: 1,
  },
  label: {
    ...textStyles['headline-medium'],
    paddingLeft: theme.other.spacing._16,
  },
}));

function FilterMultiSelect<VT>({
  filter,
  onChange,
  onClear,
  value = [],
}: {
  filter: TFilterMultiSelect<VT>;
  onChange: (value: VT[]) => void;
  onClear: (e: React.MouseEvent<HTMLButtonElement>) => (key: string) => void;
  value: VT[];
}) {
  const { classes } = useStyles();

  const handleChange = useCallback(
    (option: TFilterMultiSelect<VT>['options'][number]) =>
      (e: React.ChangeEvent<HTMLInputElement>) => {
    if (option.value === undefined) {
      return onClear(e as unknown as React.MouseEvent<HTMLButtonElement>)(filter.key);
    };
    if (e.target.checked) {
      return onChange([...value, option.value]);
    }
    return onChange(value.filter((v) => v !== option.value));
  }, [onChange, value]);

  const calculateCheckedStatus = useCallback(
    (option: TFilterMultiSelect<VT>['options'][number]) => {
      if (value.length === 0) return option.value === undefined;
      return value.includes(option.value);
    },
    [value]
  );

  return (
    <div>
      {filter.options.map((option) => (
        <div className={classes.option} key={JSON.stringify(option.value)}>
          <Checkbox
            name={filter.key}
            label={option.label}
            checked={calculateCheckedStatus(option)}
            onChange={handleChange(option)}
            classNames={{
              label: classes.label,
              labelWrapper: classes.labelWrapper,
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default FilterMultiSelect;
